import React, { FunctionComponent } from "react"
import PureImage from "../../components/Image/PureImage"
import Loader from "../../components/Loader/Loader"
import { iAsset } from "../../definitions/Assets"
import { eImageVersions } from "../../definitions/Image"
import { useImage } from "../../hooks/useImage"
import { useImageUrl } from "../../hooks/useImageUrl"

const AssetItem: FunctionComponent<iAsset> = ({
  previewVersions,
  title,
  type,
  file,
}) => {
  let src = ""
  if (type === "IMAGE") {
    const { file: fileObj, loading } =
      useImage({ fileId: file, fileCollection: "Files_Assets" }) || {}

    if (loading) {
      return (
        <div className="content-item">
          <div className="content-image">
            <Loader />
          </div>
          <div className="content-block">
            <h3>{title}</h3>
          </div>
        </div>
      )
    }
    if (fileObj) {
      src = useImageUrl(eImageVersions.original, fileObj?.versions)
    } else {
      src = "/icons/document.svg"
    }
  } else {
    src = useImageUrl(eImageVersions.LIcon, previewVersions)
  }

  return (
    <div className="content-item">
      <div className="content-image">
        <PureImage src={src} />
      </div>
      <div className="content-block">
        <h3>{title}</h3>
      </div>
    </div>
  )
}

export default AssetItem
